"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const class_variance_authority_1 = require("class-variance-authority");
const React = __importStar(require("react"));
const pi_1 = require("react-icons/pi");
const utils_1 = require("../../lib/utils");
const Command_1 = require("../Command");
const Popover_1 = require("../Popover/Popover");
const defaultStyles = "tw-flex tw-w-full tw-px-3 tw-items-center tw-rounded-md tw-border tw-border-solid tw-border-neutral-100 tw-transition-colors";
const fontStyles = "tw-text-sm tw-font-semibold tw-font-sans";
const focusStyles = "focus-visible:tw-ring-ring focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-border-primary-300";
const readOnlyStyles = "read-only:tw-bg-primaryDim-25 read-only:focus-visible:tw-border-neutral-100 read-only:focus:tw-border-transparent read-only:focus:tw-ring-0";
const lockedStyles = "read-only:tw-bg-primary-25 read-only:focus-visible:tw-border-neutral-100 read-only:focus:tw-border-transparent read-only:focus:tw-ring-0";
const selectInputVariants = (0, class_variance_authority_1.cva)([defaultStyles, fontStyles, focusStyles], {
    variants: {
        size: {
            sm: "tw-h-7",
            md: "tw-h-8",
            lg: "tw-h-9",
        },
    },
    defaultVariants: {
        size: "lg",
    },
});
const Select = React.forwardRef(({ size, placeholder = "- Select -", searchable, selected, renderSelected, onSelect = () => { }, items, className, locked, readOnly, }, ref) => {
    const [open, setOpen] = React.useState(false);
    const disabled = locked || readOnly;
    const handleSelect = (value) => {
        setOpen(false);
        // Since we hide the selected item from the list, this ensures list doesn't glitch before closing popup
        setTimeout(() => onSelect(value), 100);
    };
    const renderSelectedDisplay = () => {
        if (selected) {
            // If a custom renderSelected is provided, use that
            if (renderSelected) {
                return renderSelected;
            }
            const selectedItem = items.find((item) => item.value === selected);
            // Otherwise we want to use the provided Component or label
            if (selectedItem?.Component) {
                return React.createElement(selectedItem.Component, { ...selectedItem });
            }
            return selectedItem?.label || null;
        }
        return placeholder;
    };
    return (React.createElement(Popover_1.Popover, { open: open, onOpenChange: setOpen },
        React.createElement(Popover_1.PopoverTrigger, { disabled: disabled, className: (0, utils_1.cn)({
                [lockedStyles]: locked,
                [readOnlyStyles]: readOnly,
                "tw-cursor-default": disabled,
            }, className), ref: ref, asChild: true },
            React.createElement("button", { role: "combobox", "aria-expanded": open, className: (0, utils_1.cn)(selectInputVariants({ size }), {
                    "tw-border-neutral-100": !open,
                    "tw-border-primary-300": open,
                    "tw-text-neutral-200": !selected,
                }) },
                renderSelectedDisplay(),
                !disabled && (React.createElement(pi_1.PiCaretDownBold, { className: (0, utils_1.cn)("tw-ml-auto tw-h-4 tw-w-4 tw-shrink-0 tw-text-neutral-500 tw-transition-transform", { "tw-rotate-180": open }) })))),
        React.createElement(Popover_1.PopoverContent, { align: "start", className: "tw-min-w-60" },
            React.createElement(Command_1.Command, { tabIndex: 0, className: "tw-outline-none" },
                searchable && React.createElement(Command_1.CommandInput, { autoFocus: true, placeholder: "Search..." }),
                React.createElement(Command_1.CommandList, { className: (0, utils_1.cn)("tw-max-h-72 tw-overflow-y-auto", {
                        "tw-border-t tw-border-solid tw-border-neutral-100": searchable,
                    }) },
                    searchable && React.createElement(Command_1.CommandEmpty, null, "No results."),
                    React.createElement(Command_1.CommandGroup, null, items.map(({ value, Component, label }) => {
                        const isSelected = value === selected;
                        return (React.createElement(Command_1.CommandItem, { key: value, value: value, keywords: [label], onSelect: handleSelect, className: (0, utils_1.cn)({
                                "tw-bg-secondary-25 tw-text-secondary-300": isSelected,
                            }) },
                            Component ? (React.createElement(Component, { value: value, label: label })) : (label),
                            React.createElement(pi_1.PiCheckBold, { className: (0, utils_1.cn)("tw-ml-auto tw-h-4 tw-w-4", {
                                    "tw-opacity-0": !isSelected,
                                    "tw-text-secondary-300": isSelected,
                                }) })));
                    })))))));
});
exports.Select = Select;
Select.displayName = "Select";
